const menuAim = {
    init() {

        const mainMenu = $('.menu');


        $('.menu .menu-item-has-children').on('mouseenter', function(){

            $(this).addClass('active-sub-menu');

        })

        $('.menu .menu-item-has-children').on('mouseleave', function(){

            $(this).removeClass('active-sub-menu');

        })

    }
}
export {menuAim}